var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Heading from '@marketing/components/global/typography/Heading';
import FlexSection from '@marketing/components/sections/FlexSection';
import { clsx } from 'clsx';
import { useEffect, useRef, useState } from 'react';
import Image from '../../Media/Image';
import StepBadge from '../../StepBadge';
function Step(_a) {
    var title = _a.title, substeps = _a.substeps, stepNumber = _a.stepNumber, imageData = _a.imageData;
    var imageStyles = 'w-full md:h-[236px] aspect-[16/9] rounded-md';
    var _b = useState(false), isHalfwayInViewport = _b[0], setIsHalfwayInViewport = _b[1];
    var stepBadgeRefMobile = useRef(null);
    useEffect(function () {
        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    setIsHalfwayInViewport(true);
                }
                else {
                    setIsHalfwayInViewport(false);
                }
            });
        }, { rootMargin: '0px 0px -45% 0px' });
        if (stepBadgeRefMobile.current) {
            observer.observe(stepBadgeRefMobile.current);
        }
        return function () {
            if (stepBadgeRefMobile.current) {
                observer.unobserve(stepBadgeRefMobile.current);
            }
        };
    }, [stepBadgeRefMobile]);
    return (_jsxs(FlexSection, __assign({ className: "!justify-start", gapStyle: "w-[260px] md:w-full gap-xs-m md:gap-[60px]" }, { children: [_jsxs("div", __assign({ className: "relative flex flex-col items-center" }, { children: [_jsx(Image, { imageData: imageData, className: imageStyles }), _jsx("div", __assign({ ref: stepBadgeRefMobile, className: clsx('md:hidden mt-[-31px] z-10 duration-300 ease-in-out', isHalfwayInViewport ? 'scale-110' : 'scale-[.85]') }, { children: _jsx(StepBadge, { size: "small", step: stepNumber }) }))] })), _jsxs("div", __assign({ className: "flex flex-col justify-start items-start gap-xs-m md:gap-xl-m" }, { children: [_jsxs("div", __assign({ className: "flex justify-start items-center md:gap-xs-m self-center md:self-start" }, { children: [_jsx("div", __assign({ className: "hidden md:block" }, { children: _jsx(StepBadge, { size: "large", step: stepNumber }) })), _jsx(Heading, __assign({ size: "sm" }, { children: title }))] })), _jsx("ul", __assign({ className: "list-disc list-inside" }, { children: substeps.map(function (substep, index) { return (_jsxs("div", __assign({ className: "flex justify-start items-center" }, { children: [_jsx("li", { className: "md:pl-[16px] marker:text-[10px]" }), substep] }), index)); }) }))] }))] })));
}
export default Step;
